import React from "react";
import AnimatedSection from "../../Components/Animate/Animate";
import ReactLogo from "../../Assets/Images/tecnology/ReactIcon.png";
import Dart from "../../Assets/Images/tecnology/dart.png";
import Python from "../../Assets/Images/tecnology/python.png";
import Firebase from "../../Assets/Images/tecnology/firebase.png";
import Flutter from "../../Assets/Images/tecnology/flutter.png";
import Gdal from "../../Assets/Images/tecnology/gdal.png";
import Mongo from "../../Assets/Images/tecnology/mongo.svg";
import Node from "../../Assets/Images/tecnology/node.svg";
import Postgresql from "../../Assets/Images/tecnology/postgres.png";
import Typescript from "../../Assets/Images/tecnology/Typescript.png";
import Css from "../../Assets/Images/tecnology/css.png";
import Html from "../../Assets/Images/tecnology/html.png";
import Js from "../../Assets/Images/tecnology/js.png";
import Vercel from "../../Assets/Images/tecnology/vercel.svg";
import Hostinger from "../../Assets/Images/tecnology/hostinger.png";
import Qgis from "../../Assets/Images/tecnology/qgis.png";
import Geoserver from "../../Assets/Images/tecnology/geoserver.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Tecnologies.css";

function Tecnologies() {
  return (
    <AnimatedSection direction="right">
      <main className="tech-container">
        <div className="scroll" style={{ "--t": "20s" }}>
          <div>
            <span>HTML</span>
            <span>CSS</span>
            <span>JAVASCRIPT</span>
            <span>REACTJS</span>
            <span>FIGMA</span>
            <span>PHOTOSHOP</span>
            <span>PYTHON</span>
            <span>DART</span>
            <span>VITE</span>
            <span>TAILWIND</span>
            <span>MONGODB</span>
            <span>FLUTTER</span>
            <span>NODEJS</span>
            <span>POSTGRESQL</span>
            <span>GEOSERVER</span>
            <span>FIREBASE</span>
            <span>LEAFTLET</span>
            <span>QGIS</span>
            <span>VERCEL</span>
            <span>HOSTINGER</span>
            <span>PGADMIN</span>
          </div>
          <div>
            <span>HTML</span>
            <span>CSS</span>
            <span>JAVASCRIPT</span>
            <span>REACTJS</span>
            <span>FIGMA</span>
            <span>PHOTOSHOP</span>
            <span>PYTHON</span>
            <span>DART</span>
            <span>VITE</span>
            <span>TAILWIND</span>
            <span>MONGODB</span>
            <span>FLUTTER</span>
            <span>NODEJS</span>
            <span>POSTGRESQL</span>
            <span>GEOSERVER</span>
            <span>FIREBASE</span>
            <span>LEAFTLET</span>
            <span>QGIS</span>
            <span>VERCEL</span>
            <span>HOSTINGER</span>
            <span>PGADMIN</span>
          </div>
        </div>
        <div className="scroll" style={{ "--t": "30s" }}>
          <div>
            <span>HTML</span>
            <span>CSS</span>
            <span>JAVASCRIPT</span>
            <span>REACTJS</span>
            <span>FIGMA</span>
            <span>PHOTOSHOP</span>
            <span>PYTHON</span>
            <span>DART</span>
            <span>VITE</span>
            <span>TAILWIND</span>
            <span>MONGODB</span>
            <span>FLUTTER</span>
            <span>NODEJS</span>
            <span>POSTGRESQL</span>
            <span>GEOSERVER</span>
            <span>FIREBASE</span>
            <span>LEAFTLET</span>
            <span>QGIS</span>
            <span>VERCEL</span>
            <span>HOSTINGER</span>
            <span>PGADMIN</span>
          </div>
          <div>
            <span>HTML</span>
            <span>CSS</span>
            <span>JAVASCRIPT</span>
            <span>REACTJS</span>
            <span>FIGMA</span>
            <span>PHOTOSHOP</span>
            <span>PYTHON</span>
            <span>DART</span>
            <span>VITE</span>
            <span>TAILWIND</span>
            <span>MONGODB</span>
            <span>FLUTTER</span>
            <span>NODEJS</span>
            <span>POSTGRESQL</span>
            <span>GEOSERVER</span>
            <span>FIREBASE</span>
            <span>LEAFTLET</span>
            <span>QGIS</span>
            <span>VERCEL</span>
            <span>HOSTINGER</span>
            <span>PGADMIN</span>
          </div>
        </div>
        <div className="scroll" style={{ "--t": "15s" }}>
          <div>
            <span>HTML</span>
            <span>CSS</span>
            <span>JAVASCRIPT</span>
            <span>REACTJS</span>
            <span>FIGMA</span>
            <span>PHOTOSHOP</span>
            <span>PYTHON</span>
            <span>DART</span>
            <span>VITE</span>
            <span>TAILWIND</span>
            <span>MONGODB</span>
            <span>FLUTTER</span>
            <span>NODEJS</span>
            <span>POSTGRESQL</span>
            <span>GEOSERVER</span>
            <span>FIREBASE</span>
            <span>LEAFTLET</span>
            <span>QGIS</span>
            <span>VERCEL</span>
            <span>HOSTINGER</span>
            <span>PGADMIN</span>
          </div>
          <div>
            <span>HTML</span>
            <span>CSS</span>
            <span>JAVASCRIPT</span>
            <span>REACTJS</span>
            <span>FIGMA</span>
            <span>PHOTOSHOP</span>
            <span>PYTHON</span>
            <span>DART</span>
            <span>VITE</span>
            <span>TAILWIND</span>
            <span>MONGODB</span>
            <span>FLUTTER</span>
            <span>NODEJS</span>
            <span>POSTGRESQL</span>
            <span>GEOSERVER</span>
            <span>FIREBASE</span>
            <span>LEAFTLET</span>
            <span>QGIS</span>
            <span>VERCEL</span>
            <span>HOSTINGER</span>
            <span>PGADMIN</span>
          </div>
        </div>
        <div className="scroll" style={{ "--t": "35s" }}>
          <div>
            <span>HTML</span>
            <span>CSS</span>
            <span>JAVASCRIPT</span>
            <span>REACTJS</span>
            <span>FIGMA</span>
            <span>PHOTOSHOP</span>
            <span>PYTHON</span>
            <span>DART</span>
            <span>VITE</span>
            <span>TAILWIND</span>
            <span>MONGODB</span>
            <span>FLUTTER</span>
            <span>NODEJS</span>
            <span>POSTGRESQL</span>
            <span>GEOSERVER</span>
            <span>FIREBASE</span>
            <span>LEAFTLET</span>
            <span>QGIS</span>
            <span>VERCEL</span>
            <span>HOSTINGER</span>
            <span>PGADMIN</span>
          </div>
          <div>
            <span>HTML</span>
            <span>CSS</span>
            <span>JAVASCRIPT</span>
            <span>REACTJS</span>
            <span>FIGMA</span>
            <span>PHOTOSHOP</span>
            <span>PYTHON</span>
            <span>DART</span>
            <span>VITE</span>
            <span>TAILWIND</span>
            <span>MONGODB</span>
            <span>FLUTTER</span>
            <span>NODEJS</span>
            <span>POSTGRESQL</span>
            <span>GEOSERVER</span>
            <span>FIREBASE</span>
            <span>LEAFTLET</span>
            <span>QGIS</span>
            <span>VERCEL</span>
            <span>HOSTINGER</span>
            <span>PGADMIN</span>
          </div>
        </div>
        <div className="scroll imgbx" style={{ "--t": "25s" }}>
          <div>
            <img src={Html} alt="" />
            <img src={Css} alt="" />
            <img src={Js} alt="" />
            <img src={ReactLogo} alt="" />
            <img src={Dart} alt="" />
            <img src={Python} alt="" />
            <img src={Firebase} alt="" />
            <img src={Flutter} alt="" />
            <img src={Gdal} alt="" />
            <img src={Mongo} alt="" />
            <img src={Node} alt="" />
            <img src={Postgresql} alt="" />
            <img src={Typescript} alt="" />
            <img src={Geoserver} alt="" />
            <img src={Vercel} alt="" />
            <img src={Hostinger} alt="" />
            <img src={Qgis} alt="" />
          </div>
          <div>
            <img src={Html} alt="" />
            <img src={Css} alt="" />
            <img src={Js} alt="" />
            <img src={ReactLogo} alt="" />
            <img src={Dart} alt="" />
            <img src={Python} alt="" />
            <img src={Firebase} alt="" />
            <img src={Flutter} alt="" />
            <img src={Gdal} alt="" />
            <img src={Mongo} alt="" />
            <img src={Node} alt="" />
            <img src={Postgresql} alt="" />
            <img src={Typescript} alt="" />
            <img src={Geoserver} alt="" />
            <img src={Vercel} alt="" />
            <img src={Hostinger} alt="" />
            <img src={Qgis} alt="" />
          </div>
        </div>
      </main>
    </AnimatedSection>
  );
}

export default Tecnologies;
